import React from "react";

import useJobResultData from "hooks/useJobResultData";

import PredictionCharts from "./Charts";
import PredictionTable from "./Table";

const Prediction = ({ results, setResults, isLoading }) => {
  const { data: summary, loading: summaryLoading } = useJobResultData(
    results,
    setResults,
    "binary_predictions_summary"
  );

  const { data: output, loading: outputLoading } = useJobResultData(
    results,
    setResults,
    "binary_predictions"
  );

  return (
    <div className="flex flex-col flex-grow">
      <PredictionCharts
        summary={summary}
        isLoading={summaryLoading || isLoading}
      />
      <PredictionTable
        summary={summary}
        output={output}
        isLoading={summaryLoading || outputLoading || isLoading}
      />
    </div>
  );
};
export default Prediction;
